export default __webpack_public_path__ + "static/media/cdtc.b0f3c969.png";